export function initTopBlock(currentPage) {
	let $topBlock = currentPage.find('.top-block');
	let $title = $topBlock.find('.top-block__title');
	let $description = $topBlock.find('.top-block__text');
	let $addToCalendarButton = $topBlock.find('.top-block__button-date');

	$addToCalendarButton.on('click', () => {
		window.open(`https://calendar.google.com/event?
		action=TEMPLATE
		&text=${$title.text()}
		&details=${$description.text()}
		&dates=20190403T170000Z/20190403T205959Z
		`, '_blank');
	});
}

